import { useState } from "react";
import { useLang } from "../i18n/LanguageContext";
import PlayerForm from "../components/PlayerForm";
import SuccessScreen from "../components/SuccessScreen";
import TopBar from "../components/TopBar";

export default function HomePage() {
  const { t } = useLang();
  const [success, setSuccess] = useState(null);

  return (
    <div className="min-h-screen bg-[#080808] text-white">
      <TopBar />
      <div
        className="absolute inset-0 pointer-events-none -z-0"
        style={{
          background:
            "radial-gradient(circle at 85% 0%, rgba(232,85,154,0.12) 0%, transparent 55%), radial-gradient(circle at 0% 100%, rgba(201,64,127,0.08) 0%, transparent 55%)",
        }}
      />
      <main className="relative max-w-2xl mx-auto px-4 sm:px-6 pt-8 pb-24">
        {!success && (
          <div className="mb-8 text-center sm:text-left">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#e8559a]/30 bg-[#e8559a]/5 px-3 py-1 text-[10px] uppercase tracking-[0.3em] text-[#e8559a] mb-4">
              <span>●</span> {t("location")}
            </div>
            <h1 className="font-bebas text-5xl sm:text-6xl lg:text-7xl tracking-[0.05em] leading-[0.95]">
              {t("hero_title")}
            </h1>
            <p className="mt-3 text-neutral-400 max-w-lg sm:mx-0 mx-auto">
              {t("hero_subtitle")}
            </p>
          </div>
        )}

        {success ? (
          <SuccessScreen player={success} onNew={() => setSuccess(null)} />
        ) : (
          <PlayerForm onSuccess={setSuccess} />
        )}

        <footer className="mt-12 text-center text-xs text-neutral-600">
          <div>SOCCER TROOP · {t("instagram")} · {t("location")}</div>
        </footer>
      </main>
    </div>
  );
}
